// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles, allowedPositions }) => {
    const { user, role, position } = useAuth(); // Destructure user, role, and position from AuthContext

    // Check if the user is authenticated
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // Check if the user role is allowed
    if (allowedRoles && !allowedRoles.includes(role)) {
        return <Navigate to="/unauthorized" replace />;
    }

    // Check if the user position is allowed
    if (allowedPositions && !allowedPositions.includes(position)) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children; // Render the protected components if all checks pass
};

export default ProtectedRoute;
